import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const backfillGmailIntegration = {
  name: "backfillGmailIntegration" as const,
  input: z.object({
    integrationId: zExt.objectId(),
    days: z.number().int().min(1).max(365),
  }),
  output: z.object({ success: z.boolean() }),
};
